export const dataRefreshPanelGridTemplateColumns = 'minmax(0, 0.8fr) minmax(0, 1.9fr) minmax(0, 0.6fr) minmax(0, 0.6fr) minmax(0, 0.6fr)';
